import { atom } from 'recoil';
export type FlagsState = Record<string, boolean> | null;

export const flagsAtom = atom<FlagsState>({
  key: 'flagsAtom',
  default: null
});
